// extracted by mini-css-extract-plugin
export default {"colsPicker":"ColumnPicker_colsPicker__ALHI6","colsPickerTitle":"ColumnPicker_colsPickerTitle__I+zar","colsPickerBody":"ColumnPicker_colsPickerBody__nH1JK"};